import { Component, OnInit, ViewChild} from '@angular/core'; // , Compiler
import { AuthenticationService, MessageQueService } from '../../services/index'; //
import { Router } from '@angular/router';
import { Params } from '../../models/index';
import PasswordRulesValidator from '../../validators/passwordRulesValidator';
import { Codes } from '../../models/index';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ForgotPasswordComponent } from '../forgotPassword/forgotPassword.component';
import { ChangePasswordComponent } from '../changePassword/changePassword.component';
import PopupHelper from '../../models/popupHelper';
import { ConfirmResult, AlertResult } from '../../models/alertifyPromise';

export enum browser {
  chrome = 'Chrome',
  edge = 'Edge',
  firefox = 'Firefox',
  googlebot = 'Googlebot',
  internetExplorer = 'Internet Explorer',
  opera = 'Opera',
  safari = 'Safari',
  ucBrowsers = 'UC Browsers',
  android = 'Android',
  blackberry = 'Blackberry'
}
export enum environment {
  any = 'any', //
  galaxy = 'Galaxy Nexus', //
  nexus = 'Nexus S', //
  bb10 = 'BB10', //
  playbook = 'PlayBook 2.1', //
  blackberry99 = '9900', //
  androidMobile = 'Android Mobile', //
  androidTablet = 'Android Tablet', //
  iPhone = 'iPhone', //
  iPad = 'iPad', //
  mac = 'Mac', //
  windows = 'Windows', //
  mobile = 'Mobile', //
  xbox = 'Xbox', //
  explorer11 = 'explorer11', //
  explorer10 = 'explorer10', //
  explorer9 = 'explorer9', //
  explorer8 = 'explorer8', //
  explorer7 = 'explorer7', //
  prestoMac = '(Presto) Mac', //
  prestoWindows = '(Presto) Windows', //
  ios = 'iOS', //
  iPadI0S9 = 'iPad iOS9', //
  iPhoneI0S9 = 'iPhone iOS9', //
  smartphone = 'Smartphone', //
  windowsPhone = 'Windows Phone',
  os = 'OS' //
}

@Component({
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.scss'],
  providers: [AuthenticationService, MessageQueService]
})

export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  model: Params;
  supported = '';
  result: string;
  @ViewChild(ChangePasswordComponent) cPassword: ChangePasswordComponent;
  @ViewChild(ForgotPasswordComponent) fPassword: ForgotPasswordComponent;
  logon: boolean;
  private chngPass = false;

  constructor(private formBuilder: FormBuilder, private router: Router, private authenticationService: AuthenticationService, private msgSvc: MessageQueService) {

    this.logon = true;
  }
  ngOnInit() {
   this.msgSvc.getControlKey(); // ('CacheControlKey');

    this.detectBrowser();
    this.logon = true;
    this.loginForm = this.formBuilder.group({
      log: this.formBuilder.group({
        userName: ['', Validators.compose([
          Validators.minLength(4),
          Validators.maxLength(30),
          Validators.required])
        ],
        currentPassword: ['', Validators.compose([
          Validators.required,
          Validators.maxLength(60),
          PasswordRulesValidator()])
        ],
      })
    });
  }
  login() {
    if (this.supported === 'true') {
      const form = this.loginForm.value;
      const log: Params = Object.assign({}, form.log, {});
      this.authenticationService.login(log.userName, log.currentPassword)
        .subscribe((codes: Codes[]) => {
          const code = codes.find((rc: Codes) => rc === Codes.ok);
          if (code === Codes.ok) {
            if (this.authenticationService.isExpiring === 0) {
              this.chngPass = true;
              PopupHelper.userHelper('Your password has expired', 'error');
            } else if (this.authenticationService.isLoggedIn) {
              if (this.authenticationService.isExpiring <= 7) {
                this.confirmExpiredPassword(this.authenticationService.isExpiring);
              } else if (this.authenticationService.isReset) {
                this.chngPass = true;
                this.setDirection();
              } else {
                this.chngPass = false;
                this.setDirection();
              }
            } else if (!this.authenticationService.isLoggedIn && (this.authenticationService.isStatusInvalid === 401 ||
              this.authenticationService.isStatusInvalid === 400)) {
              this.invalidUser();
            }
          } else {
            for (const errorCode of codes) {
              switch (errorCode) {
                case Codes.requireUsername:
                  this.setValidationErrorByControlName('log.userName', 'required.');
                  break;
                case Codes.requirePassword:
                  this.setValidationErrorByControlName('log.currentPassword', 'required');
                  break;
                case Codes.accountLocked:
                  this.setValidationErrorByControlName('log.userName', 'locked');
                  break;
                default:
                  break;
              }
            }
          }
        });
    } else if (this.supported === 'false') {
      this.notSupportedBrowser();
    } else {
      this.networkProblems();
    }
  }
  setBlurById(id: string) {
    const classListPasswordSidebar = document.getElementById(id).classList;
    classListPasswordSidebar.remove('show-sidebar');
    classListPasswordSidebar.add('hide-sidebar');
  }
  setFocusById(id: string) {
    const classListPasswordSidebar = document.getElementById(id).classList;
    classListPasswordSidebar.remove('hide-sidebar');
    classListPasswordSidebar.add('show-sidebar');
  }
  passwordKeyup(event: any) {
    const password: string = event.target.value;
    this.checkLength(password);
    this.checkRegEx(password, /[!@#$%^&*(){}[\]?~<>]/, 'password-symbol-rule');
    this.checkRegEx(password, /[A-Z]/, 'password-upper-case-letter');
    this.checkRegEx(password, /[a-z]/, 'password-lower-case-letter');
    this.checkRegEx(password, /\d/, 'password-number-rule');
  }
  private checkRegEx(s: string, pattern: RegExp, id: string) {
    const isMatch = s.match(pattern);
    if (!isMatch) {
      this.showRuleNotMet(id);
    } else {
      this.showRuleMet(id);
    }
  }
  private setValidationErrorByControlName(controlName: string, validatorType: string) {
    const control = this.loginForm.get(controlName);
    const validator = {};
    validator[validatorType] = true;
    control.setErrors(validator);
    control.markAsTouched();
  }
  private checkLength(password: string) {
    const id = 'password-length-rule';
    if (password.length < 8) {
      this.showRuleNotMet(id);
    } else {
      this.showRuleMet(id);
    }
  }
  private showRuleMet(id: string) {
    const passwordLength = document.getElementById(id).classList;
    passwordLength.remove('rule-not-met');
    passwordLength.add('rule-met');
  }
  private showRuleNotMet(id: string) {
    const passwordLength = document.getElementById(id).classList;
    passwordLength.remove('rule-met');
    passwordLength.add('rule-not-met');
  }
  clear() {
    this.loginForm.reset();
    // document.getElementById('userName').focus();
  }
  // Child controls
  forgotPassword() {
    if (this.supported === 'true') {
      this.clear();
      this.fPassword.forgotPassword(true);
      this.logon = false;
    } else if (this.supported === 'false') {
      this.notSupportedBrowser();
    } else {
      this.networkProblems();
    }
  }
  changePassword() {
    if (this.supported === 'true') {
      this.clear();
      this.cPassword.passwordChange(true);
      this.logon = false;
      if (!this.cPassword.showChange) {
        this.logon = true;
      }
    } else if (this.supported === 'false') {
      this.notSupportedBrowser();
    } else {
      this.networkProblems();
    }
  }
  showLogin() {
    if (this.logon) {
      return true;
    } else {
      if (!this.cPassword.showChange && !this.fPassword.show) {
        return true;
      } else {
        return false;
      }
    }
  }
  setDirection() {
    if (this.authenticationService.isLoggedIn && !this.chngPass) {
      this.router.navigate(['navigation']);
    } else if (this.authenticationService.isLoggedIn && this.chngPass) {
      this.changePassword();
    }
  }
  async confirmExpiredPassword(daysTillExpiration) {
    const message = `Your password is scheduled to expire in ${daysTillExpiration} days.  Click OK to change password now.`;
    const confirmResult = await PopupHelper.passwordExpirationHelper(message);

    if (confirmResult === ConfirmResult.Ok) {
      this.chngPass = true;
      this.setDirection();
    } else {
      this.chngPass = false;
      this.setDirection();
    }
  }
  async invalidUser() {
    const message = 'Invalid user and/or password.  Please try again.  Access denied';
    const alertResult = await PopupHelper.userHelper(message, 'error');
    if (alertResult === AlertResult.Ok) {
      this.loginForm.reset();
      document.getElementById('userName').focus();
    }
  }
  async notSupportedBrowser() {
    const message = 'Unsupported browser detected. Please contact GIS Vendor Relations.';
    const alertResult = await PopupHelper.loginIssue(message);
    if (alertResult === AlertResult.Ok) {
      return;
    }
  }
  async networkProblems() {
    const message = 'GIS Server Not Available';
    const alertResult = await PopupHelper.loginIssue(message);
    if (alertResult === AlertResult.Ok) {
      return;
    }
  }
  detectBrowser() {
    let env = '';
    let bwsr = '';
    // Chrome
    const _isChromeAM = (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Mobile Safari') > -1 &&
      navigator.userAgent.indexOf('Nexus 5 Build') > -1 && navigator.userAgent.indexOf('Edge') === -1 &&
      navigator.userAgent.indexOf('Android') >= 6 && navigator.userAgent.indexOf('Mac') === -1 &&
      navigator.userAgent.toLowerCase().indexOf('op') === -1) ? true : false;
    const _isChromeAT = (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
      navigator.userAgent.indexOf('Nexus 7 Build') > -1 && navigator.userAgent.indexOf('Edge') === -1 &&
      navigator.userAgent.indexOf('Android') >= 4 && navigator.userAgent.indexOf('Mac') === -1 &&
      navigator.userAgent.toLowerCase().indexOf('op') === -1) ? true : false;

    const _isChromeIPhone = (navigator.userAgent.indexOf('CriOS') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
      navigator.userAgent.indexOf('Mobile') > -1 && navigator.userAgent.indexOf('iPhone') > -1 &&
      navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('Android') === -1 &&
      navigator.userAgent.toLowerCase().indexOf('op') === -1) ? true : false;
    const _isChromeIPad = (navigator.userAgent.indexOf('CriOS') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
      navigator.userAgent.indexOf('Mobile') > -1 && navigator.userAgent.indexOf('iPad') > -1 &&
      navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('Android') === -1 &&
      navigator.userAgent.toLowerCase().indexOf('op') === -1) ? true : false;
    const _isChromeOS = (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
      navigator.userAgent.indexOf('CrOS') > -1 && navigator.userAgent.indexOf('Edge') === -1 &&
      navigator.userAgent.indexOf('Android') === -1 && navigator.userAgent.toLowerCase().indexOf('op') === -1) ? true : false;
    const _isChromeMac = (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
      navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('Android') === -1 &&
      navigator.userAgent.indexOf('Macintosh') > -1 && navigator.userAgent.toLowerCase().indexOf('op') === -1) ? true : false;
    const _isChromeWindows = (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
      navigator.userAgent.indexOf('Windows NT') > -1 && navigator.userAgent.indexOf('Edge') === -1 &&
      navigator.userAgent.indexOf('Android') === -1 && navigator.userAgent.indexOf('Mac') === -1 &&
      navigator.userAgent.toLowerCase().indexOf('op') === -1) ? true : false;
    // IE
    const _isExplorer11 = ((navigator.userAgent.indexOf('Trident/7.0') > -1 && navigator.userAgent.indexOf('Windows NT 10.0') > -1) &&
      navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('WOW64') > -1) ? true : false;
    const _isExplorer10 = ((navigator.userAgent.indexOf('MSIE 10.0') > -1 && navigator.userAgent.indexOf('Windows NT 6.1') > -1) &&
      navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('Trident/6.0') > -1 &&
      navigator.userAgent.indexOf('WOW64') > -1) ? true : false;
    const _isExplorer9 = ((navigator.userAgent.indexOf('MSIE 9.0') > -1 && navigator.userAgent.indexOf('Windows NT 6.1') > -1) &&
      navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('Trident/5.0') > -1) ? true : false;
    const _isExplorer8 = ((navigator.userAgent.indexOf('MSIE 8.0') > -1 && navigator.userAgent.indexOf('Windows NT 6.0') > -1) &&
      navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('Trident/4.0') > -1) ? true : false;
    const _isExplorer7 = ((navigator.userAgent.indexOf('MSIE 7.0') > -1 && navigator.userAgent.indexOf('Windows NT 6.0') > -1) &&
      navigator.userAgent.indexOf('Edge') === -1) ? true : false;
    // Firefox
    const _isFirefoxAM = (navigator.userAgent.indexOf('Firefox') > -1 &&
      navigator.userAgent.indexOf('Mobile') > -1 && navigator.userAgent.indexOf('Android 4.4') > -1) ? true : false;
    const _isFirefoxAT = (navigator.userAgent.indexOf('Firefox') > -1 &&
      navigator.userAgent.indexOf('Tablet') > -1 && navigator.userAgent.indexOf('Android 4.4') > -1) ? true : false;
    const _isFirefoxIPhone = (navigator.userAgent.indexOf('iPhone') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
      navigator.userAgent.indexOf('FxiOS') > -1 && navigator.userAgent.indexOf('Mobile') > -1 &&
      navigator.userAgent.indexOf('iPad') === -1) ? true : false;
    const _isFirefoxIPad = (navigator.userAgent.indexOf('iPad') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
      navigator.userAgent.indexOf('FxiOS') > -1 && navigator.userAgent.indexOf('Mobile') > -1) ? true : false;
    const _isFirefoxMac = (navigator.userAgent.indexOf('Firefox') > -1 &&
      navigator.userAgent.indexOf('Macintosh') > -1) ? true : false;
    const _isFirefoxWindows = (navigator.userAgent.indexOf('Firefox') > -1 &&
      navigator.userAgent.indexOf('Windows NT 10.0') > -1) ? true : false;
    // Safari
    const _isSafariIPad = (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1 &&
      navigator.userAgent.indexOf('iPad') > -1 && navigator.userAgent.indexOf('iPhone') === -1 &&
      navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1) ? true : false;
    const _isSafariIPhone = (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1 &&
      navigator.userAgent.indexOf('iPhone') > -1 && navigator.userAgent.indexOf('iPad') === -1 &&
      navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1) ? true : false;
    const _isSafariMac = (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1 &&
      navigator.userAgent.indexOf('Macintosh') > -1) ? true : false;
    // Opera
    const _isOperaMac = (navigator.userAgent.toLowerCase().indexOf('op') > -1 && navigator.userAgent.indexOf('Chrome') > -1 &&
      navigator.userAgent.indexOf('Macintosh') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
      navigator.userAgent.indexOf('Intel Mac OS X 10_11_1') > -1) ? true : false;
    const _isOperaWindows = (navigator.userAgent.toLowerCase().indexOf('op') > -1 && navigator.userAgent.indexOf('Chrome') > -1 &&
      navigator.userAgent.indexOf('Windows NT 10.0') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
      navigator.userAgent.indexOf('WOW64') > -1) ? true : false;
    const _isOperaPMac = (navigator.userAgent.indexOf('Macintosh') > -1 && navigator.userAgent.indexOf('Presto') > -1 &&
      navigator.userAgent.indexOf('Intel Mac OS X 10.9.1') > -1) ? true : false;
    const _isOperaPWindows = (navigator.userAgent.indexOf('Presto') > -1 &&
      navigator.userAgent.indexOf('Windows NT 6.1') > -1) ? true : false;
    const _isOperaAM = (navigator.userAgent.indexOf('Presto') > -1 && navigator.userAgent.indexOf('Android 4.1') > -1 &&
      navigator.userAgent.indexOf('Opera Mobi') > -1) ? true : false;
    const _isOperaIos = (navigator.userAgent.indexOf('iPhone') > -1 && navigator.userAgent.indexOf('Presto') > -1 &&
      navigator.userAgent.indexOf('Opera Mini') > -1) ? true : false;
    // Edge
    const _isEdgeWindow = (navigator.userAgent.indexOf('Edge') > -1 && navigator.userAgent.indexOf('Chrome') > -1 &&
      navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Windows NT') >= 10 &&
      navigator.userAgent.indexOf('Xbox') === -1) ? true : false;
    const _isEdgeMobile = (navigator.userAgent.indexOf('Edge') > -1 && navigator.userAgent.indexOf('Chrome') > -1 &&
      navigator.userAgent.indexOf('Mobile Safari') > -1 && navigator.userAgent.indexOf('Windows Phone') >= 10) ? true : false;
    const _isEdgeXBox = (navigator.userAgent.indexOf('Edge') > -1 && navigator.userAgent.indexOf('Chrome') > -1 &&
      navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Windows NT') >= 10 &&
      navigator.userAgent.indexOf('Xbox') > -1) ? true : false;
    // Google
    const _isGooglebot = (navigator.userAgent.indexOf('Googlebot/2.1') > -1 &&
      navigator.userAgent.indexOf('Nexus 5X Build') === -1 && navigator.userAgent.indexOf('Android 6.0.1') === -1) ? true : false;
    const _isGooglebotS = (navigator.userAgent.indexOf('Googlebot/2.1') > -1 &&
      navigator.userAgent.indexOf('Nexus 5X Build') > -1 && navigator.userAgent.indexOf('Android 6.0.1') > -1) ? true : false;
    // UC
    const _isUCBAM = (navigator.userAgent.indexOf('UCBrowser') > -1 && navigator.userAgent.indexOf('Android 4.4.4') > -1 &&
      navigator.userAgent.indexOf('Mobile Safari') > -1) ? true : false;
    const _isUCBIOS = (navigator.userAgent.indexOf('UCBrowser') > -1 && navigator.userAgent.indexOf('iPad') > -1) ? true : false;
    const _isUCBWindowPhone = (navigator.userAgent.indexOf('UCBrowser') > -1 && navigator.userAgent.indexOf('Profile/MIDP') > -1 &&
      navigator.userAgent.indexOf('Mozilla') > -1) ? true : false;
    // Blackberry
    const _isBlackberryBB10 = (navigator.userAgent.indexOf('Mobile Safari') !== -1 &&
      navigator.userAgent.indexOf('BB10') !== -1) ? true : false;
    const _isBlackberryPlaybook = (navigator.userAgent.indexOf('Safari') !== -1 &&
      navigator.userAgent.indexOf('PlayBook') !== -1) ? true : false;
    const _isBlackberry9900 = (navigator.userAgent.indexOf('Mobile Safari') !== -1 &&
      navigator.userAgent.indexOf('BlackBerry') !== -1) ? true : false;
    // Android
    const _isAndroidGalaxy = (navigator.userAgent.indexOf('Android') !== -1 && navigator.userAgent.indexOf('Mobile Safari') !== -1
      && navigator.userAgent.indexOf('Galaxy Nexus') !== -1) ? true : false;
    const _isAndroidNexus = (navigator.userAgent.indexOf('Android') !== -1 && navigator.userAgent.indexOf('Mobile Safari') !== -1
      && navigator.userAgent.indexOf('Nexus S') !== -1) ? true : false;

    if (_isAndroidGalaxy) {
      env = environment.galaxy;
      bwsr = browser.android;
    } else if (_isAndroidNexus) {
      env = environment.nexus;
      bwsr = browser.android;
    } else if (_isBlackberryBB10) {
      env = environment.bb10;
      bwsr = browser.blackberry;
    } else if (_isBlackberryPlaybook) {
      env = environment.playbook;
      bwsr = browser.blackberry;
    } else if (_isBlackberry9900) {
      env = environment.blackberry99;
      bwsr = browser.blackberry;
    } else if (_isChromeAM) {
      env = environment.androidMobile;
      bwsr = browser.chrome;
    } else if (_isChromeAT) {
      env = environment.androidTablet;
      bwsr = browser.chrome;
    } else if (_isChromeIPhone) {
      env = environment.iPhone;
      bwsr = browser.chrome;
    } else if (_isChromeIPad) {
      env = environment.iPad;
      bwsr = browser.chrome;
    } else if (_isChromeOS) {
      env = environment.os;
      bwsr = browser.chrome;
    } else if (_isChromeMac) {
      env = environment.mac;
      bwsr = browser.chrome;
    } else if (_isChromeWindows) {
      env = environment.windows;
      bwsr = browser.chrome;
    } else if (_isEdgeWindow) {
      env = environment.windows;
      bwsr = browser.edge;
    } else if (_isEdgeMobile) {
      env = environment.mobile;
      bwsr = browser.edge;
    } else if (_isEdgeXBox) {
      env = environment.xbox;
      bwsr = browser.edge;
    } else if (_isExplorer11) {
      env = environment.explorer11;
      bwsr = browser.internetExplorer;
    } else if (_isExplorer10) {
      env = environment.explorer10;
      bwsr = browser.internetExplorer;
    } else if (_isExplorer9) {
      env = environment.explorer9;
      bwsr = browser.internetExplorer;
    } else if (_isExplorer8) {
      env = environment.explorer8;
      bwsr = browser.internetExplorer;
    } else if (_isExplorer7) {
      env = environment.explorer7;
      bwsr = browser.internetExplorer;
    } else if (_isGooglebot) {
      env = environment.any;
      bwsr = browser.googlebot;
    } else if (_isGooglebotS) {
      env = environment.smartphone;
      bwsr = browser.googlebot;
    } else if (_isFirefoxAM) {
      env = environment.androidMobile;
      bwsr = browser.firefox;
    } else if (_isFirefoxAT) {
      env = environment.androidTablet;
      bwsr = browser.firefox;
    } else if (_isFirefoxIPhone) {
      env = environment.iPhone;
      bwsr = browser.firefox;
    } else if (_isFirefoxIPad) {
      env = environment.iPad;
      bwsr = browser.firefox;
    } else if (_isFirefoxMac) {
      env = environment.mac;
      bwsr = browser.firefox;
    } else if (_isFirefoxWindows) {
      env = environment.windows;
      bwsr = browser.firefox;
    } else if (_isSafariIPad) {
      env = environment.iPadI0S9;
      bwsr = browser.safari;
    } else if (_isSafariIPhone) {
      env = environment.iPhoneI0S9;
      bwsr = browser.safari;
    } else if (_isSafariMac) {
      env = environment.mac;
      bwsr = browser.safari;
    } else if (_isUCBAM) {
      env = environment.androidMobile;
      bwsr = browser.ucBrowsers;
    } else if (_isUCBIOS) {
      env = environment.ios;
      bwsr = browser.ucBrowsers;
    } else if (_isUCBWindowPhone) {
      env = environment.windowsPhone;
      bwsr = browser.ucBrowsers;
    } else if (_isOperaMac) {
      env = environment.mac;
      bwsr = browser.opera;
    } else if (_isOperaWindows) {
      env = environment.windows;
      bwsr = browser.opera;
    } else if (_isOperaPMac) {
      env = environment.prestoMac;
      bwsr = browser.opera;
    } else if (_isOperaPWindows) {
      env = environment.prestoWindows;
      bwsr = browser.opera;
    } else if (_isOperaAM) {
      env = environment.androidMobile;
      bwsr = browser.opera;
    } else if (_isOperaIos) {
      env = environment.ios;
      bwsr = browser.opera;
    }

    try {
      if ((env !== null && env !== undefined && env !== '') && (bwsr !== null && bwsr !== undefined && bwsr !== '')) {
        this.authenticationService.checkAuthorization(env, bwsr)
          .subscribe(
            (data) => {
              this.supported = data;
            });
      } else {
        this.supported = 'false';
      }
    } catch (e) {
      this.supported = '';
    }
  }
  get userName() { return this.loginForm.get('log.userName'); }
  get currentPassword() { return this.loginForm.get('log.currentPassword'); }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts